// src/components/layout/AppLayout.jsx
import React, { useState, useCallback } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar"; 
import Sidebar from "./Sidebar"; 
import CreateAgentModal from "../agent/CreateAgentModal"; // Impor modal

const AppLayout = () => {

  const mainContentLeftPaddingLargeScreen = "lg:pl-[108px]";

  const [isCreateAgentModalOpen, setIsCreateAgentModalOpen] = useState(false);
  const location = useLocation(); 

  const openCreateAgentModal = () => setIsCreateAgentModalOpen(true);
  const closeCreateAgentModal = () => setIsCreateAgentModalOpen(false);

  const handleAgentCreatedInModal = useCallback(() => {
    closeCreateAgentModal();
    console.log(
      "Agent created via modal, MyAgentsPage should refetch if it's the current view or next view."
    );
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-black">
      {" "}
      <Navbar /> 
      <div className="flex flex-1 pt-16">
        {" "}
        <Sidebar onOpenCreateAgentModal={openCreateAgentModal} />
        <main
          className={`
            flex-1 overflow-y-auto relative 
            ${mainContentLeftPaddingLargeScreen}
            bg-slate-950 /* Latar belakang dasar untuk <main>, bisa juga gradien simpel */
            /* Contoh gradien simpel jika diinginkan: */
            /* bg-gradient-to-b from-slate-900 to-black */
          `}
        >
          <div className="p-4 sm:p-6">
            {" "}
            <div
              className="
                bg-slate-800/70 backdrop-blur-xl /* Efek glassmorphism */
                border border-slate-700/60 
                rounded-2xl 
                shadow-2xl shadow-black/40 
                min-h-[calc(100vh-4rem-4rem)] /* Tinggi Navbar (4rem) + padding atas/bawah wrapper ini (misal 2rem*2 = 4rem) */
              "
            >
              <div className="p-4 sm:p-6 lg:p-8">
                <Outlet
                  key={location.pathname}
                  context={{
                    openCreateAgentModalFromLayout: openCreateAgentModal,
                  }} 
                />
              </div>
            </div>
          </div>
        </main>
      </div>
      <CreateAgentModal
        isOpen={isCreateAgentModalOpen}
        onClose={closeCreateAgentModal}
        onAgentCreated={handleAgentCreatedInModal}
      />
    </div>
  );
};

export default AppLayout;
